import { useCallback } from 'react';
import { LocalStore } from 'constants/localstore';
import { RootState } from 'store/store';
import { useAppStore } from 'store/store-hooks';

export const useActions = () => {
  const store = useAppStore();
  const storeActions = useCallback(() => {
    const { appRestored, editorActions } = selectData(store.getState());
    if (!appRestored) return;
    localStorage.setItem(LocalStore.editorActions, JSON.stringify(editorActions));
  }, []);
  return { storeActions };
};

/* S E L E C T O R */

const selectData = (state: RootState) => {
  const { appRestored } = state.app;
  const editorActions = state.editor__actions;
  return { appRestored, editorActions };
};
